import { createSelector } from 'reselect';
import { DiscountsSubsection } from '../../types/store';
import { getStudioSlice } from './page';
import { SELLER_DISCOUNTS_STREAM } from '../../../constants';
import { getItems } from '@wix/da-shared-react/pkg/Stream/base/selectors';

export const getDiscountsSubsection = createSelector(
  [getStudioSlice],
  state => state.discounts?.subsection ?? DiscountsSubsection.Active
);

export const getDiscountLimitations = createSelector(
  [getStudioSlice],
  state => state.discounts?.limitations
);

export const getDiscountsCount = createSelector([state => state], state => {
  const items = getItems(state, SELLER_DISCOUNTS_STREAM.streamId);
  return items?.length ?? 0;
});
